import { TSupplier, getSupplierById } from "@/api";
import useSWR from "swr";

export const useSupplierById = (id: string) => {
  const { data: supplier } = useSWR(id, getSupplierById);
  return supplier;
};
